/**
 * Diagram blocks: selection list, add/edit/delete block, add person.
 * Uses window.myDiagram, sessionStorage, jQuery, document.
 */

let _currentBlockData = null;
let _tempDiagram = null;

function clearSelectedBlocksList() {
  sessionStorage['selected_nodes'] = '[]';
}

function addToDeletedBlocksList(key) {
  let deleted_blocks = JSON.parse(sessionStorage['deleted_blocks']);
  deleted_blocks = $.merge(deleted_blocks, [key]);
  sessionStorage['deleted_blocks'] = JSON.stringify(deleted_blocks);
}

function addToSelectedBlocksList(key) {
  if (!window.myDiagram) return;
  const selected_node = window.myDiagram.findNodeForKey(key).data;
  const selected_node_data = {
    std_grade_category: selected_node['std_grade_category'],
    std_grade: selected_node['std_grade'],
    std_function: selected_node['std_function'],
    function_root: selected_node['function_root'],
    std_grade_vectorized: selected_node['std_grade_vectorized'],
    std_function_category: selected_node['std_function_category'],
    key: selected_node['key'],
    parent: selected_node['parent']
  };
  let selected_nodes = JSON.parse(sessionStorage['selected_nodes']);
  selected_nodes = $.merge(selected_nodes, [selected_node_data]);
  sessionStorage['selected_nodes'] = JSON.stringify(selected_nodes);
}

function addNewNode(data) {
  if (!window.myDiagram) return;
  window.myDiagram.model.addNodeData(data);
  window.myDiagram.findNodeForKey(data.key);
}

function addBlockModal(d) {
  _tempDiagram = d;
  sessionStorage['new_block_headline'] = '';
  sessionStorage['new_block_country'] = '';
  sessionStorage['new_block_person_name'] = '';
  sessionStorage['new_block_person_title'] = '';
  if (typeof $ !== 'undefined') {
    $('#new_block_headline').val('');
    $('#new_block_country').val('');
    $('#new_block_person_name').val('');
    $('#new_block_person_title').val('');
    $(add_new_block_modal).modal('show');
  }
}

function createNewBlock() {
  sessionStorage['edit_type'] = 'added_new_block';
  const d = _tempDiagram;
  const random_key = Math.floor(Math.random() * 100000) + 100000;
  const data = {
    key: random_key,
    parent: 1,
    headline: 'pandas',
    country: 'popo pandas',
    name_0: 'panda popeye',
    title_0: 'panda poopopppp',
    image_0: 'https://res.cloudinary.com/arxena/image/upload/v1610166685/yr5sw0zxdymoawt70y3q.jpg',
    category: 'detailed',
    height_1: 0,
    height_2: 0,
    height_3: 0,
    total_people: 1,
    leadership: 'yes',
    senior_leadership: 'no'
  };
  addNewNode(data);
}

function manuallyAddPersonToBlock() {
  const editor = document.getElementById('add_person_to_block_editor');
  const button = document.getElementById('add_person_in_block_button');
  const tpl = document.getElementById('add_person_to_editor_element');
  if (editor && tpl) editor.innerHTML = tpl.innerHTML;
  if (button) button.innerHTML = '';
}

function confirmAddPersonToBlock() {
  if (!window.myDiagram) return;
  sessionStorage['edit_type'] = 'added_person_to_block';
  const node_data1 = _currentBlockData;
  if (!node_data1) return;

  let people_block_1 = [];
  for (let j = 0; j < 100; j++) {
    if (node_data1['name_' + j] != undefined && node_data1['name_' + j] != 'deleted') {
      people_block_1 = $.merge(people_block_1, [{
        id: j,
        name: node_data1['name_' + j],
        title: node_data1['title_' + j],
        image: node_data1['image_' + j],
        url: node_data1['url_' + j]
      }]);
    }
  }
  const people_block_2 = [{
    id: 0,
    name: sessionStorage['new_block_person_name'],
    title: sessionStorage['new_block_person_title'],
    image: 'https://res.cloudinary.com/Arxena/image/upload/v1610166685/yr5sw0zxdymoawt70y3q.jpg',
    url: ''
  }];

  let count = parseInt(node_data1['total_people'], 10);
  for (let j = 0; j < people_block_2.length; j++) {
    window.myDiagram.model.setDataProperty(node_data1, 'name_' + count, people_block_2[j]['name']);
    window.myDiagram.model.setDataProperty(node_data1, 'title_' + count, people_block_2[j]['title']);
    window.myDiagram.model.setDataProperty(node_data1, 'image_' + count, people_block_2[j]['image']);
    window.myDiagram.model.setDataProperty(node_data1, 'url_' + count, people_block_2[j]['url']);
    window.myDiagram.model.setDataProperty(node_data1, 'height_' + count, null);
    count += 1;
    window.myDiagram.model.setDataProperty(node_data1, 'total_people', count);
  }

  const rowEl = document.getElementById('edit_block_person_row_element');
  const peopleRows = document.getElementById('people_rows_edit');
  if (rowEl && peopleRows) {
    const new_row = rowEl.innerHTML
      .replace(/{name}/g, sessionStorage['new_block_person_name'])
      .replace(/{title}/g, sessionStorage['new_block_person_title'])
      .replace(/{image}/g, 'https://res.cloudinary.com/arxena/image/upload/v1610166685/yr5sw0zxdymoawt70y3q.jpg')
      .replace(/{url}/g, '')
      .replace(/{function}/g, "getLinkedinUrl('" + sessionStorage['new_block_person_name'] + "', '" + sessionStorage['new_block_person_title'] + "')")
      .replace(/{key}/g, node_data1.key);
    peopleRows.innerHTML = peopleRows.innerHTML + new_row;
  }

  const final_people_count = count;
  for (let j = 0; j < 4 - final_people_count; j++) {
    window.myDiagram.model.setDataProperty(node_data1, 'height_' + (3 - j), 0);
  }
  window.myDiagram.layout.invalidateLayout();

  const addEditor = document.getElementById('add_person_to_block_editor');
  const addBtn = document.getElementById('add_person_in_block_button');
  if (addEditor) addEditor.innerHTML = '';
  if (addBtn) addBtn.innerHTML = '<div class="small_button_white" style="width:100px" onclick="manuallyAddPersonToBlock()">Add person</div>';
}

function editBlockModal(data) {
  if (!window.myDiagram) return;
  _currentBlockData = data;
  const key = data['key'];
  const current_chart_data = window.myDiagram.model.nodeDataArray;
  let block = null;
  for (let i = 0; i < current_chart_data.length; i++) {
    if (current_chart_data[i]['key'] == key) {
      block = current_chart_data[i];
      break;
    }
  }
  if (!block) return;

  let rows = '';
  const rowEl = document.getElementById('edit_block_person_row_element');
  if (!rowEl) return;
  for (let j = 0; j < 100; j++) {
    if (block['name_' + j] != undefined && block['name_' + j] != 'deleted') {
      rows += rowEl.innerHTML
        .replace(/{name}/g, block['name_' + j])
        .replace(/{title}/g, block['title_' + j])
        .replace(/{image}/g, block['image_' + j])
        .replace(/{url}/g, block['url_' + j])
        .replace(/{function}/g, "new UtilityFunctions().getLinkedinUrl('" + block['name_' + j] + "', '" + block['title_' + j] + "', '" + block['url_' + j] + "', '" + block['image_' + j] + "')")
        .replace(/{key}/g, block['key']);
    }
  }
  const peopleRows = document.getElementById('people_rows_edit');
  const seeMoreHeadline = document.getElementById('see_more_headline');
  const addEditor = document.getElementById('add_person_to_block_editor');
  const addBtn = document.getElementById('add_person_in_block_button');
  if (peopleRows) peopleRows.innerHTML = rows;
  if (seeMoreHeadline) seeMoreHeadline.innerHTML = block['headline'];
  if (addEditor) addEditor.innerHTML = '';
  if (addBtn) addBtn.innerHTML = '<div class="small_button_white" style="width:100px" onclick="manuallyAddPersonToBlock()">Add person</div>';
  if (typeof $ !== 'undefined' && typeof edit_block_modal !== 'undefined') {
    $(edit_block_modal).modal('show');
  }
}

function deletePerson(user_input) {
  if (!window.myDiagram) return;
  const data = _currentBlockData;
  if (!data) return;

  sessionStorage['edit_type'] = 'deleted_person';
  const key = user_input.getAttribute('key');
  const person_name = user_input.getAttribute('person_name');

  let people = [];
  for (let j = 0; j < 100; j++) {
    if (data['name_' + j] != undefined && data['name_' + j] != 'deleted') {
      people = $.merge(people, [{
        id: j,
        name: data['name_' + j],
        title: data['title_' + j],
        image: data['image_' + j],
        url: data['url_' + j]
      }]);
    }
  }

  let count = 0;
  window.myDiagram.startTransaction('delete person');

  for (let j = 0; j < people.length; j++) {
    if (people[j]['name'] != person_name) {
      window.myDiagram.model.setDataProperty(data, 'name_' + count, people[j]['name']);
      window.myDiagram.model.setDataProperty(data, 'title_' + count, people[j]['title']);
      window.myDiagram.model.setDataProperty(data, 'image_' + count, people[j]['image']);
      window.myDiagram.model.setDataProperty(data, 'url_' + count, people[j]['url']);
      count += 1;
    } else {
      const rowEl = document.getElementById('edit_person_row_' + people[j]['url']);
      if (rowEl) rowEl.innerHTML = '';
    }
  }
  window.myDiagram.model.setDataProperty(data, 'name_' + count, 'deleted');
  window.myDiagram.model.setDataProperty(data, 'title_' + count, 'deleted');
  window.myDiagram.model.setDataProperty(data, 'image_' + count, 'deleted');
  window.myDiagram.model.setDataProperty(data, 'url_' + count, 'deleted');
  const people_left = data['total_people'] - 1;
  window.myDiagram.model.setDataProperty(data, 'total_people', data['total_people'] - 1);

  for (let j = 0; j < 4 - people_left; j++) {
    window.myDiagram.model.setDataProperty(data, 'height_' + (3 - j), 0);
  }

  window.myDiagram.layout.invalidateLayout();
  window.myDiagram.commitTransaction('delete person');
}

export {
  clearSelectedBlocksList,
  addToDeletedBlocksList,
  addToSelectedBlocksList,
  addNewNode,
  addBlockModal,
  createNewBlock,
  manuallyAddPersonToBlock,
  confirmAddPersonToBlock,
  editBlockModal,
  deletePerson
};
